  <div class="chart-container">
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [dataLabels]="chartOptions.dataLabels"
    [grid]="chartOptions.grid"
    [stroke]="chartOptions.stroke"
    [legend]="chartOptions.options.legend"
    [tooltip]="chartOptions.options.tooltip"
  ></apx-chart>
  </div>